import { IconButton } from '@deltasierra/react-components-core';
import { ComponentType, MouseEvent, useMemo } from 'react';

export type AssetLibraryGalleryGridAssetButtonProps = {
    ariaLabel: string;
    dataCy?: string;
    icon: ComponentType;
    onClick: (event: MouseEvent<HTMLElement>) => void;
    variant?: 'default' | 'selected';
};

export const AssetLibraryGalleryGridAssetButton = ({
    ariaLabel,
    dataCy,
    icon: Icon,
    onClick,
    variant = 'default',
}: AssetLibraryGalleryGridAssetButtonProps): JSX.Element => {
    const sx = useMemo(() => {
        const baseStyles = {
            borderRadius: '50%',
            padding: '3px',
        };

        if (variant === 'selected') {
            return {
                ...baseStyles,
                '&:hover': {
                    backgroundColor: 'primary.main',
                },
                backgroundColor: 'primary.main',
                color: 'common.white',
            };
        }

        return {
            ...baseStyles,
            '&:hover': {
                backgroundColor: 'primary.light',
            },
            backgroundColor: 'common.white',
            color: 'primary.main',
        };
    }, [variant]);

    return (
        <IconButton aria-label={ariaLabel} data-cy={dataCy} sx={sx} onClick={onClick}>
            <Icon />
        </IconButton>
    );
};
AssetLibraryGalleryGridAssetButton.displayName = 'AssetLibraryGalleryGridAssetButton';
